<script setup>
import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
import {RouterView} from "vue-router";
import {useDefaultStore} from "@/stores/default";
import {onMounted, ref} from "vue";
import Cmd from "@/components/admin/cmd.vue";

const defaultStore = useDefaultStore();

const main = ref(null);

onMounted(() => {
  defaultStore.setAppElement(main.value);
});
</script>

<template>
  <div ref="main" class="page-layout">
    <!--    <Sidebar/>-->
    <main class="flex flex-col min-h-screen justify-between">
      <div>
        <Header/>
        <div class="pt-10">
          <RouterView/>
        </div>
      </div>
      <Footer/>
    </main>
  </div>
  
  <Cmd/>
</template>
